// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Empty template type
 * @export
 * @enum {string}
 */
export var EmptyTemplateType;
(function (EmptyTemplateType) {
    EmptyTemplateType["Cff"] = "cff";
    EmptyTemplateType["Indices"] = "indices";
})(EmptyTemplateType || (EmptyTemplateType = {}));
export function EmptyTemplateTypeFromJSON(json) {
    return json;
}
export function EmptyTemplateTypeToJSON(value) {
    return value;
}
